import { StrictMode } from 'react'
import type { FC } from 'react'
import { ChildrenWithInjectedProps } from '@opallabs/lambda'
import * as styles from './styles'
import type { SectionProps } from './types'

export const Section: FC<React.PropsWithChildren<SectionProps>> = ({
  children,
  className,
  styleOverrides = {},
  theme = 'light',
}) => (
  <StrictMode>
    <div
      css={[styles.container({ theme }), styleOverrides]}
      {...{
        className,
      }}
    >
      <ChildrenWithInjectedProps
        {...{
          theme,
        }}
      >
        {children}
      </ChildrenWithInjectedProps>
    </div>
  </StrictMode>
)
Section.displayName = 'Lapidary Unstable: Section ← Sidebar'
